(() => {
  const runtime = window.OakaviaGalleryRuntime || (window.OakaviaGalleryRuntime = {});
  if (runtime.ready) {
    runtime.boot();
    return;
  }
  const init = root => {
    if (!root || root.dataset.oakaviaGalleryInitialized === 'true') return;
    root.dataset.oakaviaGalleryInitialized = 'true';
  const cards = [...root.querySelectorAll('[data-oakavia-gallery-card]')];
  const modal = root.querySelector('[data-oakavia-modal]');
  const modalImage = root.querySelector('[data-oakavia-modal-image]');
  const panel = root.querySelector('[data-oakavia-product-panel]');
  const productTitle = root.querySelector('[data-oakavia-product-title]');
  const productImage = root.querySelector('[data-oakavia-product-image]');
  const salePrice = root.querySelector('[data-oakavia-sale-price]');
  const comparePrice = root.querySelector('[data-oakavia-compare-price]');
  const viewProduct = root.querySelector('[data-oakavia-view-product]');
  const variantLabel = root.querySelector('[data-oakavia-variant-label]');
  const variantSelect = root.querySelector('[data-oakavia-variant-select]');
  const status = root.querySelector('[data-oakavia-status]');
  const add = root.querySelector('[data-oakavia-add]');
  const quantityInput = root.querySelector('[data-oakavia-quantity]');
  const quantityDecrease = root.querySelector('[data-oakavia-quantity-decrease]');
  const quantityIncrease = root.querySelector('[data-oakavia-quantity-increase]');
  const productCache = window.OakaviaGalleryProductCache || (window.OakaviaGalleryProductCache = new Map());
  const cardImageNodes = [...root.querySelectorAll('[data-oakavia-image-handle]')];
  let active = 0;
  let activeProduct = null;
  let renderToken = 0;
  const rootPath = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:(window.Shopify?.currency?.active || 'GBP')}).format((Number(cents) || 0) / 100);
  const safeImageUrl = value => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    try {
      const url = /^https?:\/\//i.test(raw) ? new URL(raw) : new URL(raw, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (error) {
      return '';
    }
  };
  const setStatus = text => { if (status) { status.textContent = text || ''; status.hidden = !text; } };
  const resetAddButton = (enable = true) => { if (add) { add.textContent = 'Add to basket'; add.dataset.added = 'false'; if (enable) add.disabled = false; } };
  const getQuantity = () => {
    const value = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
    if (quantityInput) quantityInput.value = String(value);
    return value;
  };
  function renderVariantPrice(variant) {
    const sellingPrice = Number(variant?.price);
    const compareAtPrice = Number(variant?.compare_at_price);
    if (!Number.isFinite(sellingPrice)) {
      salePrice.textContent = '';
      comparePrice.textContent = '';
      comparePrice.hidden = true;
      return;
    }
    salePrice.textContent = money(sellingPrice);
    const hasCompareAtPrice = Number.isFinite(compareAtPrice) && compareAtPrice > sellingPrice;
    comparePrice.hidden = !hasCompareAtPrice;
    comparePrice.textContent = hasCompareAtPrice ? money(compareAtPrice) : '';
  }
  async function fetchProduct(handle) {
    if (!handle) throw new Error('Missing product handle');
    if (!productCache.has(handle)) productCache.set(handle, fetch(`${rootPath}products/${encodeURIComponent(handle)}.js`, {headers:{Accept:'application/json'}}).then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); }));
    return productCache.get(handle);
  }
  async function hydrateCardImage(image) {
    try {
      const product = await fetchProduct(image.dataset.oakaviaImageHandle);
      const imageUrl = safeImageUrl(product.featured_image || product.images?.[0]);
      if (imageUrl) { image.src = imageUrl; image.alt = product.title || image.alt; }
    } catch (error) { /* Keep an empty card if the product image is unavailable. */ }
  }
  const setupCardImageHydration = () => {
    if (!cardImageNodes.length) return;
    if (!('IntersectionObserver' in window)) {
      cardImageNodes.forEach(hydrateCardImage);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrateCardImage(entry.target);
      });
    }, {rootMargin: '600px 0px'});
    cardImageNodes.forEach(image => observer.observe(image));
  };
  async function renderProduct(hotspot) {
    activeProduct = null;
    if (!hotspot) { panel.hidden = true; return; }
    panel.hidden = false;
    productTitle.textContent = 'Loading product…';
    productImage.removeAttribute('src');
    salePrice.textContent = '';
    comparePrice.textContent = '';
    comparePrice.hidden = true;
    viewProduct.href = '#';
    variantLabel.hidden = true;
    variantSelect.hidden = true;
    variantSelect.replaceChildren();
    add.disabled = true;
    if (quantityInput) quantityInput.value = '1';
    resetAddButton(false);
    setStatus('');
    const requestToken = ++renderToken;
    try {
      const handle = hotspot.dataset.productHandle;
      const product = await fetchProduct(handle);
      if (requestToken !== renderToken) return;
      activeProduct = product;
      productTitle.textContent = product.title || '';
      const productImageUrl = safeImageUrl(product.featured_image || product.images?.[0]);
      if (productImageUrl) productImage.src = productImageUrl;
      else productImage.removeAttribute('src');
      productImage.alt = product.title || '';
      viewProduct.href = `${rootPath}products/${encodeURIComponent(handle)}`;
      const variants = product.variants || [];
      const availableVariant = variants.find(variant => variant.available);
      if (variants.length > 1) {
        variantLabel.hidden = false;
        variantSelect.hidden = false;
        variants.forEach(variant => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = `${variant.title && variant.title !== 'Default Title' ? `${variant.title} — ` : ''}${money(variant.price)}`;
          option.disabled = !variant.available;
          variantSelect.appendChild(option);
        });
        const first = availableVariant || variants[0];
        if (first) { variantSelect.value = first.id; renderVariantPrice(first); }
      } else {
        const first = variants[0];
        renderVariantPrice(first || {price: product.price, compare_at_price: product.compare_at_price});
      }
      add.disabled = !availableVariant;
      if (!availableVariant) setStatus('This product is currently out of stock.');
    } catch (error) {
      if (requestToken !== renderToken) return;
      productTitle.textContent = 'Product unavailable';
      setStatus('This product is no longer available.');
      add.disabled = true;
    }
  }
  function openCard(index, hotspot) {
    active = (index + cards.length) % cards.length;
    const card = cards[active];
    const image = card.querySelector('.oakavia-gallery-section__image');
    modalImage.src = image.currentSrc || image.src;
    modalImage.alt = image.alt || '';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    renderProduct(hotspot || null);
  }
  variantSelect.addEventListener('change', () => {
    const variant = activeProduct?.variants?.find(item => String(item.id) === String(variantSelect.value));
    resetAddButton();
    renderVariantPrice(variant);
  });
  quantityInput?.addEventListener('input', () => { getQuantity(); resetAddButton(); });
  quantityDecrease?.addEventListener('click', () => { if (quantityInput) quantityInput.value = String(Math.max(1, getQuantity() - 1)); resetAddButton(); });
  quantityIncrease?.addEventListener('click', () => { if (quantityInput) quantityInput.value = String(getQuantity() + 1); resetAddButton(); });
  cards.forEach((card, index) => card.addEventListener('click', event => {
    const hotspot = event.target.closest('[data-oakavia-hotspot]');
    if (hotspot) { event.stopPropagation(); openCard(index, hotspot); }
    else openCard(index, null);
  }));
  const closeModal = () => { modal.hidden = true; document.body.style.overflow = ''; };
  root.querySelectorAll('[data-oakavia-close]').forEach(element => element.addEventListener('click', closeModal));
  document.addEventListener('keydown', event => { if (modal.hidden) return; if (event.key === 'Escape') closeModal(); });
  add.addEventListener('click', async () => {
    if (!activeProduct) return;
    const variant = activeProduct.variants?.find(item => String(item.id) === String(variantSelect.value)) || activeProduct.variants?.find(item => item.available) || activeProduct.variants?.[0];
    if (!variant || !variant.available) { setStatus('This product is not currently available.'); return; }
    const quantity = getQuantity();
    add.disabled = true; add.textContent = 'Adding…'; setStatus('');
    try {
      const cartComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sectionIds = cartComponent && typeof cartComponent.getSectionsToRender === 'function'
        ? cartComponent.getSectionsToRender().map(section => section.id).filter(Boolean)
        : ['cart-icon-bubble'];
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
          items: [{id: Number(variant.id), quantity}],
          sections: [...new Set(sectionIds)],
          sections_url: window.location.pathname
        })
      });
      if (!response.ok) throw new Error('Cart request failed');
      const result = await response.json();
      const cartIconMarkup = result.sections?.['cart-icon-bubble'];
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIconMarkup && cartIcon) {
        const parsedMarkup = new DOMParser().parseFromString(cartIconMarkup, 'text/html');
        const renderedIcon = parsedMarkup.querySelector('.shopify-section');
        if (renderedIcon) cartIcon.replaceChildren(...renderedIcon.childNodes);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true, detail:result}));
      setStatus('');
      add.textContent = 'Added to basket';
      add.dataset.added = 'true';
      add.disabled = true;
    } catch (error) { resetAddButton(); setStatus('Unable to add this item right now.'); }
    finally { if (add.dataset.added !== 'true') add.disabled = false; }
  });
    setupCardImageHydration();
  };

  const findRoot = target => {
    if (!target) return null;
    if (target.matches?.('[data-oakavia-gallery-root]')) return target;
    return target.querySelector?.('[data-oakavia-gallery-root]') || null;
  };
  const boot = () => document.querySelectorAll('[data-oakavia-gallery-root]').forEach(init);
  runtime.init = init;
  runtime.boot = boot;
  runtime.ready = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', event => {
    const sectionRoot = findRoot(event.target);
    if (sectionRoot) init(sectionRoot);
  });
})();
